module.exports = __webpack_public_path__ + "static/media/epaper-mobile.b0c7496d.png";